export default {
  pages: {
    acquiringBalances: {
      title: 'Список оплат',
      issueInvoice: 'Выставить счет',
    },
  },
};
